module.exports = __webpack_public_path__ + "static/media/b-meeting.89f22ca2.svg";